import {selectOwnState as selectParentState} from "../selector";
import {REDUCER_NAME} from "./const";

export const selectOwnState = state => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectSelectedImageVersions = (state) => {
    return selectOwnState(state).selectedImageVersions;
}



// WEBPACK FOOTER //
// ./src/modules/customer/state/task-widget/selector.js